import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { ChecklistProfileSurveyService } from '../../../service/checklist-profile-survey/checklist-profile-survey.service';
import { ChecklistProfileSurvey } from '../../../class/checklist-profile-survey';

@Component({
  selector: 'app-checklist-profile-survey',
  templateUrl: './checklist-profile-survey.component.html',
  styleUrls: ['./checklist-profile-survey.component.scss']
})
export class ChecklistProfileSurveyComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoChecklistProfileSurvey: ChecklistProfileSurvey;
    public archive: ChecklistProfileSurvey;
    public msgs: Message[] = [];
    public options: any;
    public latitude: number;
    public longitude: number;
    public zoom: number;
    public overlays: any[];

    constructor(
        public archiveService: ChecklistProfileSurveyService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    private setPosition(position) {
        this.latitude = position.lat;
        this.longitude = position.lng;
        this.zoom = 17;
    }

    public addMarker(lat, lng, title) {
        this.longitude = lng;
        this.latitude = lat;
        this.overlays = [];
        this.overlays.push(
            new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                }, title: title}
            )
        );
    }

    public cancelChecklistProfileSurvey () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/checklist-profile-surveis/checklist-profile-survey/checklist-profile-survey.component.ts